<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-row>
        <!-- Inicio Panel FILTRO -->
        <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
          <vs-card style="border-radius: 1.5em;">
            <div slot="header">
              <h3 class="card-title mb-0">Información de filtro</h3>
            </div>
            <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
            <vs-row>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <!-- Selector de empresa -->
                <company-selector v-model="companyId"/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha inicial</label>
                <vs-input type="date" v-model="initialDate" class="w-100 "/>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
                <label class="vs-input--label">Fecha final</label>
                <vs-input type="date" v-model="finalDate" class="w-100 "/>
              </vs-col>
            </vs-row>
            <br/>
            <vs-row>
              <!-- Selector de tipo de servicio -->
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereStations">
                <label class="vs-input--label">Estación de pago</label>
                <multiselect v-model="selectedStations" placeholder="Seleccione una estación" label="name"
                             track-by="code" :options="showStations" :multiple="true"
                             :taggable="true" :max-height="150" :max="50">
                </multiselect>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereStations">
                <label class="vs-input--label">Método de pago factura</label>
                <multiselect v-model="selectedMethods" placeholder="Seleccione un método de pago" label="name"
                             track-by="code" :options="showMethods" :multiple="true"
                             :taggable="true" :max-height="150" :max="50">
                </multiselect>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="12" v-if="thereStations">
                <label class="vs-input--label">Número de factura</label>
                <vs-input type="text" v-model="searchBillNumber" class="w-100 "/>
              </vs-col>
            </vs-row>
            <vs-row>
            </vs-row>
            <hr class="custom-hr"/>
            <div class="d-inline-block d-md-flex align-items-center">
              <div class="btn-alignment">
                <vs-button :disabled="!isSearch" @click="listPreview()">Buscar</vs-button>
                <vs-button color="gray" @click="clearForm()">Limpiar</vs-button>
              </div>
              <div class="ml-auto mt-3 mt-md-0">
                <div class="d-flex align-items-center">
                  <div class="d-flex align-items-center dropdownbtn-alignment ml-3">
                    <vs-button :disabled="!isDownloadable" class="btnx" type="filled" color="danger"
                               @click="downloadReport()">
                      <i class="ti-upload mr-2"></i>Exportar
                    </vs-button>

                    <vs-dropdown>
                      <vs-button class="btn-drop" type="filled" color="danger" icon="expand_more"></vs-button>
                      <vs-dropdown-menu>
                        <vs-button class="dropdown-item" color="'default'" v-for="document in documents"
                                   :value="document.id" :key="document.id"
                                   :id="document.id" @click="formatType=document.id">{{ document.name }}
                        </vs-button>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
            <hr class="custom-hr"/>
            <!-- Inicio Panel totales -->
            <vs-card v-if="showTable">
              <div class="d-md-flex align-items-center">
                <div>
                  <h3 class="card-title">Totalidad de ingresos de su estacionamiento</h3>
                </div>

              </div>
              <vs-row vs-justify="center">
                <vs-col vs-lg="4" vs-xs="12" vs-sm="4">
                  <h1 class="mb-0 mt-4"> {{ totalSold }} </h1>

                  <h4 class="font-weight-light ">Valor total</h4>
                  <h2 class="mb-0 mt-4">{{ totalTax }}</h2>
                  <h4 class="font-weight-light ">Impuesto facturado</h4>
                </vs-col>
                <vs-col vs-lg="8" vs-xs="12" vs-sm="8">
                  <div v-if="showTable">
                    <vs-row class="mt-4">
                      <vs-col
                          vs-xs="12"
                          v-for="(totalBilling, index) in totalsBilling"
                          :key="index"
                          :class="[ totalBilling.gridlg, totalBilling.gridsm ]"
                      >
                        <div class="d-flex align-items-center">
                          <div class="mr-2">
            <span class="display-4" :class="[ totalBilling.iconcolor ]">
              <i :class="[ totalBilling.icon]"></i>
            </span>
                          </div>
                          <div>
                            <span :class="[ totalBilling.textcolor ]">{{ totalBilling.text }}</span>
                            <h3 class="font-medium mb-0">{{ totalBilling.money }}</h3>
                          </div>
                        </div>
                      </vs-col>
                    </vs-row>
                  </div>
                </vs-col>
              </vs-row>
            </vs-card>
            <!-- Fin Panel totales -->
          </vs-card>
        </vs-col>
        <!-- Inicio tabla de previsualización -->
        <vs-col vs-lg="12" vs-xs="12" v-if="showTable">
          <div style="max-height: 40em; overflow-y: auto;">
            <vs-card style="border-radius: 1.5em;">
              <h3 class="card-title d-flex">
                Tabla de previsualización
              </h3>
              <vs-table :data="tableData">
                <template slot="thead">
                  <vs-th sort-key="prefix">Prefijo documento equivalente</vs-th>
                  <vs-th sort-key="invoiceNumber"> Número documento equivalente</vs-th>
                  <vs-th sort-key="creationDate"> Fecha de creación</vs-th>
                  <vs-th sort-key="methodPay">Método de pago</vs-th>
                  <vs-th sort-key="taxdto">Impuesto factura</vs-th>
                  <vs-th sort-key="totalPaid">Total factura</vs-th>
                  <vs-th sort-key="taxPercentage">Porcentaje impuesto</vs-th>
                  <vs-th sort-key="userName">Usuario liquidación</vs-th>
                  <vs-th sort-key="monthlyName">Nombre cliente</vs-th>
                  <vs-th sort-key="monthlyId">Documento cliente</vs-th>
                  <vs-th>Detalle de conceptos</vs-th>
                  <vs-th>Copia de factura</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr,indextr) in data">
                    <vs-td :data="data[indextr].prefix">
                      {{ data[indextr].prefix }}
                    </vs-td>
                    <vs-td :data="data[indextr].invoiceNumber">
                      {{ data[indextr].invoiceNumber }}
                    </vs-td>
                    <vs-td :data="data[indextr].creationDate">
                      {{ data[indextr].creationDate }}
                    </vs-td>
                    <vs-td :data="data[indextr].methodPay">
                      {{ data[indextr].methodPay }}
                    </vs-td>
                    <vs-td :data="data[indextr].taxdto">
                      {{ data[indextr].taxdto }}
                    </vs-td>
                    <vs-td :data="data[indextr].totalPaid">
                      {{ data[indextr].totalPaid }}
                    </vs-td>
                    <vs-td :data="data[indextr].taxPercentage">
                      {{ data[indextr].taxPercentage }}%
                    </vs-td>
                    <vs-td :data="data[indextr].userName">
                      {{ data[indextr].userName }}
                    </vs-td>
                    <vs-td :data="data[indextr].monthlyName">
                      {{ data[indextr].monthlyName }}
                    </vs-td>
                    <vs-td :data="data[indextr].monthlyId">
                      {{ data[indextr].monthlyId }}
                    </vs-td>
                    <vs-td :data="data[indextr]">
                      <vs-button class="flex-shrink-0 small   ml-auto"
                                 color="primary"
                                 @click="view(data[indextr])"
                      >Conceptos
                      </vs-button>
                    </vs-td>
                    <vs-td :data="data[indextr]">
                      <vs-button class="flex-shrink-0 small   ml-auto"
                                 color="primary"
                                 @click="copyInvoice(data[indextr])"
                      >Copia
                      </vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <vs-pagination
                  :total="Math.ceil(total/perPage)"
                  :per-page="perPage"
                  v-model="page"/>
              <vs-prompt
                  color="primary"
                  :active.sync="activePrompt"
                  title="Conceptos de factura"
              >
                <div v-bar class="vs-scrollable" style="height: 350px;">
                  <div>
                    <div class="p-2 pb-0">
                      <h3 style="font-weight: 100" class="mb-2">Ajuste de factura</h3>
                      <h2 class="mb-3">{{ movementSelected.parkingAdjustment }}</h2>
                      <hr>
                      <h3 style="font-weight: 100" class="mb-2">Subtotal parqueadero</h3>
                      <h2 class="mb-3">{{ movementSelected.subtotalParking }}</h2>
                      <hr>
                      <h3 style="font-weight: 100" class="mb-2">Subtotal perdido</h3>
                      <h2 class="mb-3">{{ movementSelected.lostSubtotal }}</h2>
                      <hr>
                      <h3 style="font-weight: 100" class="mb-2">Subtotal misceláneo</h3>
                      <h2 class="mb-3">{{ movementSelected.miscellaneousSubtotal }}</h2>
                      <hr>
                      <h3 style="font-weight: 100" class="mb-2">Subtotal mensual</h3>
                      <h2 class="mb-3">{{ movementSelected.subtotalMonthly }}</h2>
                    </div>
                  </div>
                </div>
              </vs-prompt>
            </vs-card>
          </div>
        </vs-col>
        <!-- Fin de tabla de previsalizacion -->

      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import deviceEndpoint from "@/endpoints/machine/DeviceEndpoint";
import unityEndpoint from "@/endpoints/core/UnityEndpoint";
import multiselect from "vue-multiselect";
import toast from "@/global/ToastConfig";
import DateUtils from "@/global/DateUtils";
import Treeselect from "@riophae/vue-treeselect";
import CompanySelector from "@/components/Shared/CompanySelector/index.vue";
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";
import centroMayorEndpoint from "@/endpoints/reports/centro-mayor/centroMayorEndpoint";
import downloadEndpoint from "@/endpoints/download/downloadEndpoint";
import {renderPropsTotals} from "@/global/utils"

export default {
  name: "detail-invoice",
  components: {
    Treeselect,
    CompanySelector,
    multiselect
  },
  data() {
    return {
      totalsBilling: [],
      initialDate: null,
      finalDate: null,
      companyId: null,
      isLoading: false,
      showTable: false,
      tableData: [],
      activePrompt: false,
      page: 1,
      perPage: 50,
      total: 0,
      movementSelected: {},
      documents: [
        {name: ".xlsx", id: "xlsx"},
      ],
      totalPages: 0,
      thereStations: false,
      selectedStations: [],
      showStations: [],
      listStations: [],
      selectedMethods: [],
      showMethods: [],
      listMethods: [],
      searchBillNumber: null,
      isSearch: false,
      isDownloadable: false,
      forceRender: 0,
      totalSold: "",
      totalTax: ""
    }

  },
  watch: {
    /**
     * Observa el companyId y realiza una accion si este cambia
     */
    companyId() {
      this.isDownloadable = false;
      this.isSearch = false;
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.showMethods = [];
      this.selectedStations = [];
      this.selectedMethods = [];
      this.page = 1;
      this.initialDate = null;
      this.finalDate = null;
      this.validateParams();
    },
    /**
     * Observa el initialDate y realiza una accion si este cambia
     */
    initialDate() {
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.showMethods = [];
      this.selectedStations = [];
      this.selectedMethods = [];
      this.page = 1;
      this.validateParams();
    },
    /**
     * Observa el finalDate y realiza una accion si este cambia
     */
    finalDate() {
      this.showTable = false;
      this.tableData = [];
      this.showStations = [];
      this.showMethods = [];
      this.selectedStations = [];
      this.selectedMethods = [];
      this.page = 1;
      this.validateParams();
    },
    /**
     * Observa el page y realiza una accion si este cambia
     */
    page() {
      this.listPreview();
    },
    selectedStations() {
      this.tableData = [];
      this.showTable = false;
      this.page = 1;
    },
    selectedMethods() {
      this.tableData = [];
      this.showTable = false;
      this.page = 1;
    },
    searchBillNumber() {
      this.tableData = [];
      this.showTable = false;
      this.page = 1;
    },
    showMethods() {
      this.thereStations = this.showMethods.length > 0;
    }
  },
  methods: {
    /**
     * Metodo que limpia el formulario inicial
     */
    clearForm() {
      this.companyId = null;
      this.initialDate = null;
      this.finalDate = null;
      this.showTable = false;
      this.tableData = [];
      this.thereBill = false;
      this.thereMethods = false;
      this.selectedMethods = [];
      this.selectedStations = [];
      this.searchBillNumber = null;
      this.page = 1;
      this.isSearch = false;
      this.isDownloadable = false;
      this.totalsBilling = [];
    },
    /**
     * metodo que valida si los parametros  de los servicios de traer los
     * metodos de pago y las estaciones son los correctos si no sale y no los muestra y no ejecuta el servicio
     * @returns {Promise<void>}
     */
    validateParams() {
      this.isLoading = true;
      if (!this.companyId) {
        this.thereStations = false;
        this.isLoading = false;
        return;
      }
      if (!this.finalDate || !this.initialDate) {
        this.thereStations = false;
        this.isLoading = false;
        return;
      }
      this.listDevices();
      this.listMethod();
    },
    /**
     * Metodo que asigna los parametros para descarga y previsualizacion del reporte
     * @returns {{finalDate: string, companyId: null, initialDate: string}}
     */
    prepareParameters() {
      return {
        companyId: this.companyId,
        initialDate: DateUtils.toDateShortString({
          date: this.initialDate,
        }),
        finalDate: DateUtils.toDateShortString({
          date: this.finalDate,
        }),
        page: this.page - 1,
        typeMethods: this.getValidateMethods(),
        typeDevices: this.getValidateStations(),
        billsNumber: this.searchBillNumber
      }
    },
    /**
     *  metodo que valida si seleccionaron una estacion o si no que tenga encuenta todas las estaciones
     * @returns {string}
     */
    getValidateStations() {
      return this.selectedStations.length === 0
          ? this.showStations.map(item => item.code).join(",")
          : this.selectedStations.map(item => item.code).join(",")
    },
    /**
     *  metodo que valida si seleccionaron un metodo de pago o si no que tenga encuenta todos los metodos
     * @returns {string}
     */
    getValidateMethods() {
      return this.selectedMethods.length === 0
          ? this.showMethods.map(item => item.code).join(",")
          : this.selectedMethods.map(item => item.code).join(",")
    },
    /**
     * Metodo que valida mis parametros en la interfaz grafica
     * para no hecer peticiones erroneas al servidor
     * @returns {Promise<void>}
     */
    validateForm() {
      if (!this.finalDate || !this.initialDate) {
        this.isLoading = false;
        throw new Error("Debe seleccionar la fecha inicial y/o  la fecha final");
      }
      const validDates = DateUtils.isBefore({
        before: this.finalDate,
        date: this.initialDate,
      });
      if (validDates) {
        this.isLoading = false;
        throw new Error(" La fecha final no puede ser inferior a  la fecha inicial");
      }
      if (!this.companyId) {
        this.isLoading = false;
        throw new Error("Seleccione una compañia");
      }
    },
    /**
     * Metodo de descarga del reporte por medio de una promesa
     * @returns {Promise<void>}
     */
    downloadReport() {
      try {
        this.isLoading = true;
        toast.info('Cargando reporte');
        this.validateForm();
        const objParams = this.prepareParameters();
        parkingReportsEndpoints.downloadInvoiceDetail(objParams)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              downloadEndpoint.downloadFile(data.info);
              this.isLoading = false;
            })
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * Metodo que genera la previsualizacion de la tabla por medio de una promesa
     * @returns {Promise<void>}
     */
    listPreview() {
      try {
        this.isLoading = true;
        toast.info('Cargando información');
        this.validateForm();
        const objParams = this.prepareParameters();
        parkingReportsEndpoints.listInvoiceDetail(objParams)
            .then(data => {
              if (data.code <= 0) {
                this.isLoading = false;
                return;
              }
              this.tableData = data.info.records;
              this.total = data.info.totalRecords;
              this.totalSold = data.info.totalizedTotal;
              this.totalTax = data.info.totalizedTax;
              this.getTotals(data);
              this.showTable = true;
              this.isLoading = false;
            });

      } catch (error) {
        toast.error(error.message);
        this.isLoading = false;
      }
    },
    /**
     *
     * @returns {Promise<void>}
     */
    listMethod() {
      try {
        this.showMethods = [];
        this.validateForm();
        const objParams = this.prepareParameters();
        unityEndpoint.listByPayAndBilling(objParams)
            .then(data => {
              if (data.length === 0) {
                this.isLoading = false;
                this.isSearch = false;
                this.isDownloadable = false;
                this.thereStations = false;
                return;
              }
              data.forEach((unityC) => {
                const concept = {
                  name: unityC.title,
                  code: unityC.code,
                };
                this.showMethods.push(concept);
              });
              this.isSearch = true;
              this.isDownloadable = true;
              this.thereStations = true;
              this.isLoading = false;
            });
        this.forceRender++;
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * metodo que lista las estaciones que facturaron en el rango de fecha ingresado
     * @returns {Promise<void>}
     */
    listDevices() {
      try {
        this.showStations = [];
        this.validateForm();
        const objParams = this.prepareParameters();
        deviceEndpoint.listByBillingRange(objParams)
            .then(data => {
              if (data.length === 0) {
                this.isLoading = false;
                return;
              }
              data.forEach((station) => {
                const unity = {
                  name: station.nickname == null ? station.title : station.nickname,
                  code: station.code,
                };
                this.showStations.push(unity);
              });
            });
        this.forceRender++;
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * Metodo que recolecta los datos a mostrar cuando  dan click en ver los detalles de los conceptos en la tabla
     * @param conceptObj
     */
    view(conceptObj) {
      console.log(conceptObj, typeof (conceptObj));
      this.movementSelected = conceptObj;
      this.activePrompt = true;
    },
    /**
     * Metodo que recolecta los datos para realizar la descarga de l copia de factura
     * @param invoiceInfo
     * @returns {Promise<void>}
     */
    copyInvoice(invoiceInfo) {
      try {
        this.isLoading = true;
        toast.info('Cargando copia de factura');
        const params = {
          companyId: this.companyId,
          invoicePrefix: invoiceInfo.prefix,
          invoiceNumber: invoiceInfo.invoiceNumber,
          dateSearch: invoiceInfo.creationDate,
        }
        centroMayorEndpoint.downloadMallInvoiceCopy(params)
            .then(data => {
              if (data.code < 0) {
                this.isLoading = false;
                return;
              }
              downloadEndpoint.downloadFile(data.info);
            });
        this.isLoading = false;
      } catch (error) {
        toast.error(error.message);
      }
    },
    /**
     * Obtiene los totales de facturación y los enlista para renderizarlos
     * @param objInfo
     */
    getTotals(objInfo) {
      const data = objInfo.info;
      const keys = Object.keys(data);
      const totals = [];

      keys.forEach(key => {
        if (key !== "totalRecords" &&
            key !== "records" &&
            key !== "totalizedTotal" &&
            key !== "totalizedTax" &&
            key !== "totalizedQuantity" &&
            data[key] !== null
        ) {
          totals.push({
            "text": key,
            "money": data[key]
          });
        }
      });
      this.totalsRender(totals);
    },
    /**
     * rederizar los totales de facturación
     * @param totalsList
     */
    totalsRender(totalsList) {
      this.totalsBilling = [];
      this.totalsBilling = totalsList.map(item => ({
        gridlg: "vs-lg-6",
        gridsm: "vs-sm-6",
        iconcolor: renderPropsTotals(item.text).color,
        icon: "mdi " + renderPropsTotals(item.text).icon,
        textcolor: "text-dark",
        text: renderPropsTotals(item.text).title,
        money: item.money
      }));
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"/>

